// extracted by mini-css-extract-plugin
module.exports = {"title":"Section_title__YPi42","alignLeftTitle":"Section_alignLeftTitle__2-sK7","section":"Section_section__KorBz"};